var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a = require("lodash"), isObject = _a.isObject, isArray = _a.isArray, isBoolean = _a.isBoolean;
var isGalleryObject = require('./gallery').isGalleryObject;
var _b = require('./utils'), isEmptyMessengerData = _b.isEmptyMessengerData, isEmptyObj = _b.isEmptyObj;
var _c = require("lodash"), isUndefined = _c.isUndefined, isNull = _c.isNull;
var _d = require('./utils'), transliterate = _d.transliterate, isFile = _d.isFile;
var hasRole = require('./auth').hasRole;
var _e = require('./date'), getTime = _e.getTime, timestampToDate = _e.timestampToDate;
var removeAllHtmlTags = require('./text').removeAllHtmlTags;
var getClientCityTimezone = require('../configs/general').getClientCityTimezone;
export function getRootParent(parent, allNodeData) {
    var rootNode;
    var parentNodes = [];
    if (!parent)
        return;
    parent.map(function (node) {
        if (!allNodeData[node].parent) {
            rootNode = node;
        }
        else {
            parentNodes.push(node);
        }
    });
    if (rootNode)
        return rootNode;
    parentNodes.map(function (node) {
        rootNode = getRootParent(allNodeData[node].parent, allNodeData);
    });
    return rootNode;
}
export function getURI(parent, fields, nodeConfig, configs, city) {
    if (!parent)
        return '\\';
    var uri = parent;
    if (parent[parent.length - 1] !== '\\') {
        uri += '\\';
    }
    if (nodeConfig.uriStructure) {
        uri += getNodeID(fields, nodeConfig, configs, city);
    }
    else {
        uri += transliterate(fields.title);
    }
    return uri;
}
export function getNodeID(fields, nodeConfig, configs, city) {
    var result = "";
    nodeConfig.uriStructure.map(function (field, i) {
        if (!fields[field])
            return;
        if (nodeConfig.fields[field].type === 'timestamp') {
            var timeZone = getClientCityTimezone(configs, city);
            if (i > 0) {
                result += '-';
            }
            result += transliterate(getTime(timestampToDate(fields[field]), timeZone).format('YYYY-MM-DD-HH-mm-ss'));
        }
        else if (isArray(fields[field])) {
            if (i > 0) {
                result += '-';
            }
            result += transliterate(fields[field].join('-'));
        }
        else {
            if (i > 0) {
                result += '-';
            }
            result += transliterate(fields[field]);
        }
    });
    return result;
}
export function getFieldStatus(field, roles) {
    var _a, _b, _c, _d, _e, _f;
    var edit = 'hidden';
    if (!field)
        return {
            edit: edit,
        };
    if (!((_a = field === null || field === void 0 ? void 0 : field.access) === null || _a === void 0 ? void 0 : _a.edit)) {
        edit = 'editable';
    }
    else if (hasRole((_b = field.access) === null || _b === void 0 ? void 0 : _b.edit, roles)) {
        edit = 'editable';
    }
    if (((_c = field === null || field === void 0 ? void 0 : field.options) === null || _c === void 0 ? void 0 : _c.autoUpdatable) || ((_d = field === null || field === void 0 ? void 0 : field.options) === null || _d === void 0 ? void 0 : _d.notUpdatable)) {
        if (edit === 'editable') {
            edit = 'disabled';
        }
    }
    if (((_e = field === null || field === void 0 ? void 0 : field.options) === null || _e === void 0 ? void 0 : _e.showDisabledIfHasNoAccess) && !hasRole((_f = field.access) === null || _f === void 0 ? void 0 : _f.edit, roles)) {
        edit = 'disabled';
    }
    return { edit: edit };
}
export function removeSentitiveData(data, fieldsConfig, roles) {
    Object.keys(fieldsConfig).map(function (fieldId) {
        var _a, _b;
        if (((_b = (_a = fieldsConfig[fieldId]) === null || _a === void 0 ? void 0 : _a.access) === null || _b === void 0 ? void 0 : _b.sensitive) &&
            getFieldStatus(fieldsConfig[fieldId], roles)["edit"] === "hidden") {
            if (data === null || data === void 0 ? void 0 : data[fieldId])
                delete data[fieldId];
        }
    });
    return data;
}
export function validateExtraConditions(nodeConfig, fields) {
    var errors = {};
    if (!fields)
        return errors;
    var regexpFields = [];
    {
        Object.keys(nodeConfig).map(function (field) {
            var _a, _b;
            if (!nodeConfig[field])
                return;
            if ((_b = (_a = nodeConfig[field]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.multiple) {
                regexpFields.push(field);
            }
        });
    }
    regexpFields.map(function (fieldId) {
        var value = fields[fieldId];
        if (nodeConfig[fieldId].options.multiple) {
            if ((value / nodeConfig[fieldId].options.multiple).toString().includes('.')) {
                errors[fieldId] = "\u0427\u0438\u0441\u043B\u043E \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043A\u0440\u0430\u0442\u043D\u0438\u043C ".concat(new Intl.NumberFormat("uk-UA", {}).format(parseInt(nodeConfig[fieldId].options.multiple)));
                return true;
            }
        }
    });
    {
        Object.keys(nodeConfig).map(function (fieldId) {
            var _a, _b, _c, _d;
            var value = fields[fieldId];
            if (value && ((_b = (_a = nodeConfig[fieldId]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.maxLength) && ((_c = removeAllHtmlTags(value)) === null || _c === void 0 ? void 0 : _c.length) > nodeConfig[fieldId].options.maxLength) {
                errors[fieldId] = "\u041F\u0435\u0440\u0435\u0432\u0438\u0449\u0435\u043D\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432";
                return true;
            }
            if (nodeConfig[fieldId] && nodeConfig[fieldId].type === 'instagram' && (value === null || value === void 0 ? void 0 : value.includes("instagram.com"))) {
                errors[fieldId] = "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0432\u043A\u0430\u0437\u0430\u0442\u0438 \u043B\u0438\u0448\u0435 \u043D\u0456\u043A\u043D\u0435\u0439\u043C, \u0431\u0435\u0437 https://instagram.com";
                return true;
            }
            if (nodeConfig[fieldId] && nodeConfig[fieldId].type === 'email' && ((_d = value === null || value === void 0 ? void 0 : value.split("@")) === null || _d === void 0 ? void 0 : _d.length) > 2) {
                errors[fieldId] = "\u041D\u0435 \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 email";
                return true;
            }
        });
    }
    return errors;
}
export function validateFieldDataFormat(fieldConfig, value) {
    if ((fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.type) === 'email') {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value))
            return "\u041D\u0435 \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 email";
    }
    return null;
}
export function validateFormDataFormat(nodeConfig, fields) {
    var errors = {};
    if (!fields)
        return errors;
    {
        Object.keys(nodeConfig).map(function (fieldId) {
            var err = validateFieldDataFormat(nodeConfig[fieldId], fields[fieldId]);
            if (err)
                errors[fieldId] = err;
        });
    }
    return errors;
}
export function validateRegExpFields(nodeConfig, fields) {
    var regexpFields = [];
    {
        Object.keys(nodeConfig).map(function (field) {
            var _a, _b;
            if (!nodeConfig[field])
                return;
            if ((_b = (_a = nodeConfig[field]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.regexp) {
                regexpFields.push(field);
            }
        });
    }
    var errors = {};
    if (!fields)
        return errors;
    regexpFields.map(function (fieldId) {
        var _a;
        var value = fields[fieldId];
        if (nodeConfig[fieldId].type === 'list') {
            var hasError = false;
            value === null || value === void 0 ? void 0 : value.map(function (item) {
                var regex = new RegExp(nodeConfig[fieldId].options.regexp);
                if (item && !regex.test(item)) {
                    errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u0437\u0430\u0431\u043E\u0440\u043E\u043D\u0435\u043D\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0438";
                    return true;
                }
            });
            return hasError;
        }
        if (nodeConfig[fieldId].type === 'price') {
            value = (_a = fields[fieldId]) === null || _a === void 0 ? void 0 : _a.price;
        }
        var regex = new RegExp(nodeConfig[fieldId].options.regexp);
        if (value && !regex.test(value)) {
            errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u0437\u0430\u0431\u043E\u0440\u043E\u043D\u0435\u043D\u0456 \u0441\u0438\u043C\u0432\u043E\u043B\u0438";
            return true;
        }
    });
    return errors;
}
export function getFormErrors(fields, newForm, isEditMode) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, validateRequiredFields(fields, newForm, isEditMode)), validateRegExpFields(fields, newForm)), validateRequiredFiles(fields, newForm, newForm)), validateRequiredGalleriesOnClient(fields, newForm)), validateRequiredLogo(fields, newForm, {})), validateFormDataFormat(fields, newForm)), validateExtraConditions(fields, newForm));
}
export function validateRequiredFields(nodeConfig, fields, isEditMode) {
    var requiredFields = [];
    var ignore = ['image', 'gallery', 'logo'];
    {
        Object.keys(nodeConfig).map(function (field) {
            if (!nodeConfig[field])
                return;
            if (nodeConfig[field].required && !ignore.includes(nodeConfig[field].type)) {
                requiredFields.push(field);
            }
        });
    }
    var errors = {};
    if (!fields)
        return errors;
    requiredFields.map(function (fieldId) {
        var _a, _b;
        var field = nodeConfig[fieldId];
        if (isHiddenField(field, fields))
            return false;
        if (field && field.type === 'json' && fields[fieldId]) {
            var value = JSON.stringify(fields[fieldId]);
            var def = JSON.stringify(nodeConfig[fieldId].default);
            if (value === def) {
                errors[fieldId] = "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0440\u0438\u043A\u043B\u0430\u0434 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0435\u043D\u043D\u044F\u043C";
                return true;
            }
            if (isArray(fields[fieldId]) && fields[fieldId].length === 0) {
                errors[fieldId] = "\u041C\u0430\u0441\u0438\u0432 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0438\u0439";
                return true;
            }
            if (!isArray(fields[fieldId]) && typeof fields[fieldId] === 'object' && Object.keys(fields[fieldId]).length === 0) {
                errors[fieldId] = "\u041E\u0431\u0454\u043A\u0442 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0438\u0439";
                return true;
            }
            if (isEmptyObj(fields[fieldId])) {
                errors[fieldId] = 'Поле обовязкове для заповнення';
                return true;
            }
            return false;
        }
        if (field && field.type === 'messenger') {
            if (isEmptyMessengerData(fields[fieldId])) {
                errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0438\u043C";
                return true;
            }
        }
        if (field && field.type === 'location' && isLocationEmpty(fields[fieldId])) {
            errors[fieldId] = "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043B\u043E\u043A\u0430\u0446\u0456\u044E \u043D\u0430 \u043C\u0430\u043F\u0456";
            return true;
        }
        if (field && field.type === 'filter' && isFilterEmpty(fields[fieldId])) {
            errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0438\u043C";
            return true;
        }
        if (field && field.type === 'boolean' && isUndefined(fields[fieldId])) {
            errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434\u043C\u0456\u0447\u0435\u043D\u0438\u043C";
            return true;
        }
        if (field && field.type === 'checkbox' && !fields[fieldId]) {
            errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434\u043C\u0456\u0447\u0435\u043D\u0438\u043C";
            return true;
        }
        if (field && field.type === 'number' && !fields[fieldId]) {
            errors[fieldId] = "\u041F\u043E\u043B\u0435 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0438\u043C";
            return true;
        }
        if (field && field.type === 'productAddons' && isEmptyObj(((_a = fields[fieldId]) === null || _a === void 0 ? void 0 : _a.list) || {})) {
            errors[fieldId] = "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0443 \u043E\u043F\u0446\u0456\u044E";
            return true;
        }
        if (field && field.type === 'productOptions' && isEmptyObj(((_b = fields[fieldId]) === null || _b === void 0 ? void 0 : _b.list) || {})) {
            errors[fieldId] = "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D \u0432\u0430\u0440\u0456\u0430\u043D\u0442";
            return true;
        }
        if (isNull(fields[fieldId]) || isUndefined(fields[fieldId]) || (!isNull(fields[fieldId]) && fields[fieldId].length === 0)) {
            errors[fieldId] = 'Поле обовязкове для заповнення';
            return true;
        }
    });
    return errors;
}
export function validateRequiredFiles(nodeConfig, files, fields) {
    var requiredFields = [];
    var accept = ['image'];
    {
        Object.keys(nodeConfig).map(function (field) {
            if (!nodeConfig[field])
                return;
            if (nodeConfig[field].required && accept.includes(nodeConfig[field].type)) {
                requiredFields.push(field);
            }
        });
    }
    var errors = {};
    if (!fields)
        return errors;
    requiredFields.map(function (fieldId) {
        var field = nodeConfig[fieldId];
        if (field && field.type === 'image') {
            if (isFile(files[fieldId])) {
                if (files[fieldId].size === 0) {
                    errors[fieldId] = 'Поле обовязкове до заповнення';
                    return true;
                }
            }
        }
        if (isUndefined(files[fieldId]) && !fields[fieldId]) {
            errors[fieldId] = 'Поле обовязкове для заповнення';
            return true;
        }
    });
    return errors;
}
export function validateRequiredGalleriesOnClient(nodeConfig, content) {
    var errors = {};
    Object.keys(nodeConfig).map(function (fieldId) {
        var field = nodeConfig[fieldId];
        if (field && field.required && field.type === 'gallery') {
            if ((!content[fieldId] || isEmptyObj(content[fieldId]))
                || (isGalleryObject(content[fieldId]) && Object.keys(content[fieldId]).length === 0)
                || (isArray(content[fieldId]) && content[fieldId].length === 0)) {
                errors[fieldId] = 'Галерея обовязкова до заповнення';
                return true;
            }
            if (isGalleryObject(content[fieldId]) && Object.keys(content[fieldId]).length > 0) {
                var allFilesAreNull_1 = true;
                Object.keys(content[fieldId]).map(function (file) {
                    if (isFile(content[fieldId][file])) {
                        if (content[fieldId][file].size > 0)
                            allFilesAreNull_1 = false;
                    }
                    else {
                        if (content[fieldId][file].length > 0)
                            allFilesAreNull_1 = false;
                    }
                });
                if (allFilesAreNull_1) {
                    errors[fieldId] = 'Галерея обовязкова до заповнення';
                    return true;
                }
            }
        }
    });
    return errors;
}
export function validateRequiredLogo(nodeConfig, files, fields) {
    var requiredFields = [];
    var accept = ['logo'];
    {
        Object.keys(nodeConfig).map(function (field) {
            if (!nodeConfig[field])
                return;
            if (nodeConfig[field].required && accept.includes(nodeConfig[field].type)) {
                requiredFields.push(field);
            }
        });
    }
    var errors = {};
    if (!fields)
        return errors;
    requiredFields.map(function (fieldId) {
        if (!fields[fieldId] && !files[fieldId]) {
            errors[fieldId] = 'Поле обовязкове до заповнення';
            return true;
        }
    });
    return errors;
}
export function validateRequiredGalleriesOnServer(nodeConfig, files, fields) {
    var errors = {};
    if (!fields)
        return errors;
    Object.keys(nodeConfig).map(function (fieldId) {
        var _a;
        var field = nodeConfig[fieldId];
        if (field && field.required && field.type === 'gallery') {
            if (isArray(fields[fieldId]) && fields[fieldId].length === 0) {
                errors[fieldId] = 'Галерея обовязкова до заповнення';
                return true;
            }
            if (!isArray(fields[fieldId])) {
                var hasFilesToLeave = ((_a = fields[fieldId]) === null || _a === void 0 ? void 0 : _a.leaveThoseFiles.length) > 0;
                var hasFilesToUpload = files[fieldId]
                    && ((isArray(files[fieldId]) && files[fieldId].length > 0)
                        || (!isArray(files[fieldId]) && isFile(files[fieldId]) && files[fieldId].size > 0));
                var hasFiles = hasFilesToUpload || hasFilesToLeave;
                if (!hasFiles) {
                    errors[fieldId] = 'Галерея обовязкова до заповнення';
                    return true;
                }
            }
        }
    });
    return errors;
}
export function checkNodeAddRequirements(requirements, data) {
    var result = [];
    if (!requirements)
        return result;
    requirements.map(function (rule) {
        switch (rule) {
            case 'user.messenger':
                if (!data.user.messenger) {
                    result.push('Додати дані месенджеру на сторінці вашого профілю');
                }
                break;
        }
    });
    return result;
}
export function isHiddenField(config, content) {
    var result = false;
    if (config === null || config === void 0 ? void 0 : config.visible)
        result = isHidden(config.visible, content);
    function isHidden(config, content) {
        var isHidden = true;
        Object.keys(config).map(function (field) {
            if (!isHidden)
                return;
            if (config[field][0] === '=') {
                var values = config[field].substring(1);
                if (values[0] === '[' && values[values.length - 1] === ']') {
                    values = values.substring(1, values.length - 1).split(',').map(function (i) { return i.trim(); });
                }
                else {
                    values = [values];
                }
                var v = content[field];
                if (isBoolean(v))
                    v = v.toString();
                if (values.includes(v)) {
                    isHidden = false;
                }
            }
            else if (config[field] === 'not-empty-field') {
                if (Boolean(content[field])) {
                    isHidden = false;
                }
            }
            else if (config[field][0] === '<') {
                if (content[field] < Number(config[field].substring(1))) {
                    isHidden = false;
                }
            }
            else if (config[field][0] === '>') {
                if (content[field] > Number(config[field].substring(1))) {
                    isHidden = false;
                }
            }
        });
        return isHidden;
    }
    return result;
}
export function isLocationEmpty(field) {
    if ((field === null || field === void 0 ? void 0 : field.type) === 'search')
        return !Boolean((field === null || field === void 0 ? void 0 : field.link) && (field === null || field === void 0 ? void 0 : field.title) && (field === null || field === void 0 ? void 0 : field.address) && (field === null || field === void 0 ? void 0 : field.lat) && (field === null || field === void 0 ? void 0 : field.lng));
    return !Boolean((field === null || field === void 0 ? void 0 : field.lat) && (field === null || field === void 0 ? void 0 : field.lng));
}
export function isFilterEmpty(field) {
    if (isArray(field)) {
        if (field.length === 0)
            return true;
    }
    else if (isObject(field)) {
        if (!(field === null || field === void 0 ? void 0 : field.value) && !(field === null || field === void 0 ? void 0 : field.else))
            return true;
        if ((field === null || field === void 0 ? void 0 : field.value) === '_else' && !(field === null || field === void 0 ? void 0 : field.else))
            return true;
        if ((field === null || field === void 0 ? void 0 : field.else) || (field === null || field === void 0 ? void 0 : field.value))
            return false;
    }
    else {
        if (!field)
            return true;
    }
    return false;
}
